import * as PATHS from 'js/constants/pathnames';
import { DatasetCatalog } from 'new/components/settings/Integrations/DatasetCatalog';
import styles from 'new/components/settings/Teams/Teams.module.scss';
import { Tabs } from 'new/elements/Tabs';
import PageLayout from 'new/elements/pageLayout/PageLayout';
import { ScreenComponent } from 'new/routes/RouterManager';
import React, { useState } from 'react';
import { GenAIIntegrations } from 'src/new/components/settings/Integrations/GenAIIntegrations';
import { DeactivateIntegration } from 'new/components/settings/Integrations/IntegrationList/DeactivateIntegration';
import { useHistory } from 'react-router-dom';

interface IntegrationsProps {}

const tabs = [
  {
    value: 'data_catalog',
    label: 'Data Catalogs',
    Component: DatasetCatalog,
  },
  {
    value: 'gen_ai',
    label: 'Gen AI Integrations',
    Component: GenAIIntegrations,
  },
];

export const Integrations: ScreenComponent<IntegrationsProps> = () => {
  const history = useHistory();
  const initialParams = new URLSearchParams(history.location.search);
  const [selectedTab, setSelectedTab] = useState(initialParams.get('activeTab') || 'data_catalog');

  const onTabChange = (event, value) => {
    setSelectedTab(value);
  };

  const Component = tabs.find((tab) => tab.value === selectedTab).Component;

  return (
    <PageLayout
      title="App Integrations"
      description="Inter-operate Nexla with your existing enterprise application stack."
    >
      <div className={styles.tabs}>
        <Tabs value={selectedTab} tabs={tabs} onChange={onTabChange} />
      </div>
      <Component />
    </PageLayout>
  );
};

Integrations.screenConfig = {
  path: `${PATHS.ROUTE_REDESIGN}/settings/app-integrations`,
  modals: [DeactivateIntegration],
  screenName: 'App Integrations',
  pageTitle: 'App Integrations',
  header: {
    title: 'Settings',
    slugTitle: 'App Integrations',
  },
  domain: 'settings',
};
